// ตัวตน (profile จาก PaymentBroker) + บัญชีใน RTDB (แพ็กเกจ/โควตา/กระเป๋า token) + ราคา + รายการโมเดล
import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { authService } from "../services/auth";
import { AUTH_EVENT, USER_TYPE } from "../services/config";
import { getStoredProfile, getRawToken } from "../services/apiClient";
import { users, balanceOf } from "../services/users";
import { getPricing, DEFAULT_PRICING } from "../services/pricing";
import { getModelOverrides } from "../services/admin";
import { mergeModels } from "../services/ai/models";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [profile, setProfile] = useState(() => (getRawToken() ? getStoredProfile() : null));
  const [account, setAccount] = useState(null);
  const [pricing, setPricing] = useState(DEFAULT_PRICING);
  const [models, setModels] = useState(() => mergeModels({}));

  useEffect(() => {
    const sync = () => setProfile(getRawToken() ? getStoredProfile() : null);
    window.addEventListener(AUTH_EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(AUTH_EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  const reloadCatalog = useCallback(async () => {
    const [p, o] = await Promise.all([getPricing({ fresh: true }).catch(() => DEFAULT_PRICING), getModelOverrides()]);
    setPricing(p);
    setModels(mergeModels(o));
  }, []);
  useEffect(() => {
    reloadCatalog();
  }, [reloadCatalog]);

  const refreshAccount = useCallback(async () => {
    const p = getRawToken() ? getStoredProfile() : null;
    if (!p?.uid) {
      setAccount(null);
      return null;
    }
    try {
      const u = await users.get(p.uid);
      setAccount(u);
      return u;
    } catch (e) {
      return null;
    }
  }, []);
  useEffect(() => {
    refreshAccount();
  }, [profile?.uid, refreshAccount]);

  const value = useMemo(
    () => ({
      profile,
      account,
      pricing,
      models,
      balance: account ? balanceOf(account, pricing) : null,
      isLoggedIn: !!profile,
      isSuperUser: profile?.user_type === USER_TYPE.superUser,
      setAccount,
      refreshAccount,
      reloadCatalog,
      logout: authService.logout,
    }),
    [profile, account, pricing, models, refreshAccount, reloadCatalog]
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
